import React from "react";

export function PhoneLoadingIcon({ vectorEffect, ...rest }: React.ComponentProps<"svg">) {
  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <rect
        x="8"
        y="1"
        width="16"
        height="30"
        rx="2"
        fill="#EFEFEF"
        stroke="#33514A"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <line
        x1="14.4648"
        y1="3.71155"
        x2="17.5363"
        y2="3.71155"
        stroke="#33514A"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16 12.6614V11.6786"
        stroke="#33514B"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M18.5391 13.7129L19.2362 13.0157"
        stroke="#33514B"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M19.5898 16.25H20.5727"
        stroke="#33514B"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M18.5391 18.7871L19.2362 19.4843"
        stroke="#33514B"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16 19.8386V20.8215"
        stroke="#33514B"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.4628 18.7871L12.7656 19.4843"
        stroke="#33514B"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.4125 16.25H11.4297"
        stroke="#33514B"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.4628 13.7129L12.7656 13.0157"
        stroke="#33514B"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
